import { render, staticRenderFns } from "./viewTrivia.vue?vue&type=template&id=438702b4&scoped=true&"
import script from "./viewTrivia.vue?vue&type=script&lang=js&"
export * from "./viewTrivia.vue?vue&type=script&lang=js&"
import style0 from "./viewTrivia.vue?vue&type=style&index=0&id=438702b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438702b4",
  null
  
)

export default component.exports